import { render } from "./QuickpayMarketingPreferences.vue?vue&type=template&id=4fd2379f&scoped=true"
import script from "./QuickpayMarketingPreferences.vue?vue&type=script&lang=js"
export * from "./QuickpayMarketingPreferences.vue?vue&type=script&lang=js"

import "./QuickpayMarketingPreferences.vue?vue&type=style&index=0&id=4fd2379f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd2379f"]])

export default __exports__